export const Env = {
  MANUAL_MAX_CAPACITY: Number(process.env.REACT_APP_MANUAL_MAX_CAPACITY) || 1000,
  MANUAL_MIN_CAPACITY: Number(process.env.REACT_APP_MANUAL_MIN_CAPACITY) || -1000,
  SREG_MAX_CAPACITY: Number(process.env.REACT_APP_SREG_MAX_CAPACITY) || 1000,
  DREG_MAX_CAPACITY: Number(process.env.REACT_APP_DREG_MAX_CAPACITY) || 1000,
};
